import { useAppDispatch, useAppSelector } from '@shared/model';
import { Report } from '@pages/invoice-generator/shared/ui/Report/Report';
import {
  selectFailedGeneration,
  selectGeneratedSuccessfullyCount,
  selectGeneratedTotal,
  selectGenerationErrors,
  selectGenerationLoading,
  setGenerationIsLoading,
} from '@entities/generation-state';
import { useElapsedTime } from '@pages/invoice-generator/shared/lib/hooks';
import { formatTime } from '@pages/invoice-generator/shared/lib/utils';
import { setGenerationIsTimedOut } from '@pages/invoice-generator/shared/model';
import { ReportListItem } from '@pages/invoice-generator/shared/ui/Report/components/ReportListItem';

export const GenerationReport = () => {
  const generatedTotal = useAppSelector(selectGeneratedTotal);
  const failedTotal = useAppSelector(selectFailedGeneration);
  const generatedSuccessfully = useAppSelector(selectGeneratedSuccessfullyCount);
  const generationErrors = useAppSelector(selectGenerationErrors);
  const isLoading = useAppSelector(selectGenerationLoading);
  const startedAt = useAppSelector(state => state.reportsSection.generationReport.startedAt);
  const isTimedOut = useAppSelector(state => state.reportsSection.generationReport.isTimedOut);

  const dispatch = useAppDispatch();
  const { elapsedTime, finishedAt } = useElapsedTime(isLoading);

  const retryGeneration = () => {
    dispatch(setGenerationIsLoading(true));
    dispatch(setGenerationIsTimedOut(false));
  };

  return (
    <Report
      reportTitle="Invoice Generation Report"
      errors={generationErrors}
      isTimedOut={isTimedOut}
      onRetry={retryGeneration}
      data-id="generation-report"
    >
      <ReportListItem data-id="started-at-li" title="Started at" value={new Date(startedAt).toLocaleString()} />
      <ReportListItem
        data-id="finished-at-li"
        title="Finished at"
        value={isLoading ? 'In progress' : new Date(finishedAt).toLocaleString()}
      />
      <ReportListItem data-id="duration-li" title="Duration" value={formatTime(elapsedTime)} />
      <ReportListItem data-id="total-li" title="Total" value={String(generatedTotal)} />
      <ReportListItem data-id="success-li" title="Success" value={String(generatedSuccessfully)} />
      <ReportListItem data-id="failed-li" title="Failed" value={String(failedTotal)} />
    </Report>
  );
};
